import { Component, effect, inject } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';

import { RaceSessionService } from '@vbrick/vb-lxp-lib';

@Component({
	selector: 'app-pre-race.component',
	imports: [],
	templateUrl: './pre-race.component.html',
	styleUrl: './pre-race.component.css',
})
export class PreRaceComponent {
	private router = inject(Router);
	private route = inject(ActivatedRoute);
	private raceSessionService = inject(RaceSessionService);

	constructor() {
		effect(() => {
			if (this.raceSessionService.raceTeamsPosition().length > 0) {
				this.router.navigate([''], {
					queryParams: this.route.snapshot.queryParams,
				});
			}
		});
	}
}
